module.exports = __webpack_public_path__ + "static/media/IMG_9844.9a79f642.jpg";